import { TextConfig } from "slotworks/config/asset-config-schema";
import { ButtonState } from "slotworks/graphics/elements/button-element";
import Layers from "slotworks/graphics/layers/layers";
import { ExtendedTextStyle, MultiStyleText } from "slotworks/graphics/pixi/pixi-multistyle-text";
import Translations from "slotworks/i18n/translations";

export function populateText(texts: TextConfig[], layer: Layers) {
    // Populate text as designed in asset works
    if (texts) {
        for (const textConfig of texts) {

            // Text
            const id = textConfig.id;
            const idParts = id.split("-");

            let text: PIXI.extras.BitmapText | PIXI.Text;

            if (textConfig.fontVariant === "bmp") {
                // Bitmap font
                text = new PIXI.extras.BitmapText(textConfig.content,
                    {
                        font: {
                            size: textConfig.size,
                            name: textConfig.fontFamily
                        }
                    });

            } else {
                // Regular text
                const textFormat = {
                    fontFamily: textConfig.fontFamily + "-" + textConfig.fontVariant,
                    fontSize: textConfig.size,
                    fill: textConfig.color,
                    wordWrap: true,
                    wordWrapWidth: textConfig.width,
                    height: textConfig.height,
                    width: textConfig.width,
                    breakWords: Translations.breakWords,
                    trim: false,
                    align: textConfig.align
                } as ExtendedTextStyle;

                // Stroke
                if (textConfig.strokeThickness) {
                    textFormat.stroke = textConfig.stroke;
                    textFormat.strokeThickness = textConfig.strokeThickness * 2;
                }

                // Gradient fill
                if (textConfig.fill) {
                    textFormat.fill = textConfig.fill;
                    textFormat.fillGradientStops = textConfig.fillGradientStops;
                    textFormat.fillGradientType = textConfig.fillGradientType;
                }

                // Drop shadow
                if (textConfig.dropShadowBlur) {
                    textFormat.dropShadow = true;
                    textFormat.dropShadowAlpha = textConfig.dropShadowAlpha;
                    textFormat.dropShadowAngle = (180 - textConfig.dropShadowAngle) * Math.PI / 180;
                    textFormat.dropShadowBlur = textConfig.dropShadowBlur / 2;
                    textFormat.dropShadowColor = textConfig.dropShadowColor;
                    textFormat.dropShadowDistance = 1 + textConfig.dropShadowDistance * 1.5;
                }

                // Content and localisation
                let content = textConfig.content;

                if (content.slice(0, 1) === "[") {
                    const translationID = content.slice(1, content.indexOf("]"));
                    content = processTranslation(translationID);
                }

                if (content.indexOf("#") > -1) {
                    content = "";
                }

                text = new MultiStyleText(content, {
                    default: textFormat,
                    ...Translations.formats
                });
            }

            // Position
            text.x = textConfig.x;
            text.y = textConfig.y;
            text.name = id;

            // Alignment
            if (textConfig.align === "center") {
                text.anchor = new PIXI.Point(0.5, 0.5);
                text.x += textConfig.width * 0.5;
                text.y += textConfig.height * 0.5;
            } else if (textConfig.align === "right") {
                text.anchor = new PIXI.Point(1, 0);
                text.x += textConfig.width;
            }

            layer.add(text);

            if (idParts[0] === "lbl") {
                processLabel(layer, text, idParts[1], idParts[2]);
            }
        }
    }
}

export function processTranslation(translationID: string): string {
    let translation = Translations.get(translationID);

    const pTagsToStrip = /(?:<p>)|(?:<\/p>(?!.|\s*<\/p>))/gim;
    const pTagsToReplace = /<\/p>/gi;

    translation = translation.replace(pTagsToStrip, "");
    translation = translation.replace(pTagsToReplace, "\n\n");

    return translation;
}

export function processLabel(layer: Layers, label: PIXI.extras.BitmapText | PIXI.Text, buttonName: string, state: string) {
    const button = layer.getButton(buttonName);

    if (button) {
        button.addLabelForState(label, ButtonState.FromString(state));
    }
}



// WEBPACK FOOTER //
// ./~/slotworks/graphics/layers/populators/populate-text.ts